module.exports = __webpack_public_path__ + "assets/img/07e9-sr.svg";